export default __webpack_public_path__ + "media/images/icons/google-0a6d43ddabd5c193d21a77d43bd817a2.svg";